import { t } from '@lingui/macro'
import { Link } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { Flex, FlexColumn, Margin } from '@/@bothrs-ui/web/components/layout'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { H2, H3 } from '@/@bothrs-ui/web/components/typography/Heading'
import { NativePlatform } from '@/capacitor/components/native-platform/NativePlatform'
import { mixpanel } from '@/mixpanel'
import { capitalize, formatLocale } from '@/modules/shared/helpers/locale'
import { StDescription } from './TimelineEmpty.styled'

const TimelineEmpty = () => {
  const theme = useTheme()
  const startMonth = formatLocale(new Date(), 'MMMM')

  return (
    <FlexColumn justifyContent={'space-between'} style={{ height: '100%' }}>
      <H3>{capitalize(startMonth)}</H3>
      <FlexColumn flexGrow={1} justifyContent={'space-between'} alignItems={'center'}>
        <FlexColumn flexGrow={1} justifyContent={'center'} alignItems={'center'} gap={theme.UI.Spacing.Space2}>
          <Flex justifyContent={'center'} alignItems={'center'}>
            <img src='/img/svg/empty-calendar.svg' alt='Kalender icon' />
          </Flex>
          <H2 noMargin>
            {t({
              id: 'appointments.timeline.empty.title',
              comment: 'Empty calendar title',
              message: 'Nog niets gepland',
            })}
          </H2>
          <StDescription type='BodyLargeRegular' textAlign='center'>
            {t({
              id: 'appointments.timeline.empty.body',
              comment: 'Empty calendar body',
              message:
                'Je hebt nog niets in je agenda ingepland. Boek een eerste afspraak. Het kan enkele minuten duren voor je afspraak hier verschijnt.',
            })}
          </StDescription>
        </FlexColumn>
        <NativePlatform>
          <Link to='/appointment'>
            <Button
              variant='Primary'
              prefixIcon={['fal', 'calendar-plus']}
              onClick={() => {
                mixpanel.track('appointment_booking_start', {
                  origin: 'agenda',
                })
              }}
            >
              {t({
                id: 'appointments.timeline.empty.primary',
                comment: 'Primary button empty calendar',
                message: 'Boek een eerste afspraak',
              })}
            </Button>
          </Link>
        </NativePlatform>
        <Margin mb={theme.UI.Spacing.Space8} />
      </FlexColumn>
    </FlexColumn>
  )
}

export { TimelineEmpty }
